import {
  Box,
  Card,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import { getColor } from "../../style/color/color";
import { Info } from "@mui/icons-material";
import { formatToIndianCurrency } from "../../logic/CurrencyFormatter";
import { String } from "../../constants/Strings";
import { fonts } from "../../style/fonts/fonts";

const TotalAmountCard = ({
  totalnetWorth,
  totalLibalities,
  monthlySaving,
  monthlyEMIs,
}) => {
  return (
    <Card
      sx={{
        background: getColor.SecondarySummerSky,
        display: "flex",
        justifyContent: "space-around",
        p: 1,
        borderRadius: 3,
      }}
    >
      <Stack sx={{ mr: "20px", textAlign: "left" }}>
        <Box sx={{ mb: "20px", p: 1 }}>
          <Typography
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 20,
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            {formatToIndianCurrency(totalnetWorth)}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <Typography
              sx={{
                color: getColor.PrimaryWhite,
                fontSize: 12,
                fontFamily: fonts.manrope,
                fontWeight: "500",
              }}
            >
              {String.Dashboard.totolAMountCardTooltip.TitleNetworth}
            </Typography>
            <Tooltip
              title={String.Dashboard.totolAMountCardTooltip.netWorthTitle}
              sx={{ position: "relative", ml: "5px" }}
              enterTouchDelay={0}
            >
              <IconButton>
                <Info
                  sx={{
                    width: 12,
                    height: 12,
                    fontSize: "1rem",
                    color: getColor.PrimaryWhite,
                    left: 0,
                    top: 4,
                    position: "absolute",
                    cursor: "pointer",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Box sx={{ mb: "30px", p: 1 }}>
          <Typography
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 20,
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            {formatToIndianCurrency(monthlySaving)}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <Typography
              sx={{
                color: getColor.PrimaryWhite,
                fontSize: 12,
                fontFamily: fonts.manrope,
                fontWeight: "500",
              }}
            >
              {String.Dashboard.totolAMountCardTooltip.titleMonthlysaving}
            </Typography>
            <Tooltip
              title={String.Dashboard.totolAMountCardTooltip.monthlySavingTitle}
              sx={{ position: "relative", ml: "5px" }}
              enterTouchDelay={0}
            >
              <IconButton>
                <Info
                  sx={{
                    width: 12,
                    height: 12,
                    fontSize: "1rem",
                    color: getColor.PrimaryWhite,
                    left: 0,
                    top: 4,
                    position: "absolute",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Stack>
      <Stack sx={{ textAlign: "right" }}>
        <Box sx={{ mb: "30px", mt: "10px" }}>
          <Typography
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 20,
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            {formatToIndianCurrency(totalLibalities)}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Typography
              sx={{
                color: getColor.PrimaryWhite,
                fontSize: 12,
                fontFamily: fonts.manrope,
                fontWeight: "500",
              }}
            >
              {String.Dashboard.totolAMountCardTooltip.titleLiabalities}
            </Typography>
            <Tooltip
              title={
                String.Dashboard.totolAMountCardTooltip.totalLiabilitiesTitle
              }
              sx={{ position: "relative", ml: "5px" }}
              enterTouchDelay={0}
            >
              <IconButton>
                <Info
                  sx={{
                    width: 12,
                    height: 12,
                    fontSize: "1rem",
                    color: getColor.PrimaryWhite,
                    left: 2,
                    top: 4,
                    position: "absolute",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
        <Box sx={{ mb: "30px", mt: "10px" }}>
          <Typography
            sx={{
              color: getColor.PrimaryWhite,
              fontSize: 20,
              fontFamily: fonts.manrope,
              fontWeight: "700",
            }}
          >
            {formatToIndianCurrency(monthlyEMIs)}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Typography
              sx={{
                color: getColor.PrimaryWhite,
                fontSize: 12,
                fontFamily: fonts.manrope,
                fontWeight: "500",
                ml: "30px",
              }}
            >
              {String.Dashboard.totolAMountCardTooltip.titlemontlhyEmI}
            </Typography>
            <Tooltip
              title={String.Dashboard.totolAMountCardTooltip.monthlyEMITitle}
              sx={{ position: "relative", ml: "5px" }}
              enterTouchDelay={0}
            >
              <IconButton>
                <Info
                  sx={{
                    width: 12,
                    height: 12,
                    fontSize: "1rem",
                    color: getColor.PrimaryWhite,
                    left: 2,
                    top: 4,
                    position: "absolute",
                  }}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Stack>
    </Card>
  );
};

export default TotalAmountCard;
